var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.584 7.062l.074.092 1.71 2.43a1 1 0 01-1.558 1.25l-.078-.099-.328-.465c-.983 3.154-3.95 5.48-7.405 5.48-2.632 0-5.038-1.302-6.418-3.425a1 1 0 011.677-1.09c1.01 1.554 2.785 2.515 4.741 2.515 2.409 0 4.508-1.539 5.353-3.673l-.347.257a1 1 0 01-1.287-1.527l.096-.08 2.43-1.8a1 1 0 011.34.135zM10 .25c2.754 0 5.256 1.422 6.62 3.731A1 1 0 1114.9 5c-1.004-1.7-2.85-2.749-4.9-2.749-2.47 0-4.598 1.54-5.384 3.773l.4-.28a1 1 0 011.248 1.556l-.098.079-2.43 1.71a1 1 0 01-1.33-.163l-.073-.093-1.71-2.52a1 1 0 011.584-1.216l.071.092.342.505C3.583 2.49 6.549.25 9.999.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/Rewind.5e5add59.svg";
export { ForwardRef as ReactComponent };